<template>
  <div class="form-rows" style="margin-bottom: 20px;">
    <div class="card-title">
      直播记录
      <template>
        <el-link type="primary" icon="el-icon-refresh" @click="getList"/>
        <el-link type="primary" v-permission="'order_live_data_record_save'" icon="el-icon-plus"
                 style="margin-left: 10px" title="添加录" @click="handleAdd"/>
      </template>
    </div>

    <div class="form-card">
      <ml-table ref="MlTable" :api="getOrderLiveDataList" :search="{order_id: orderId}" height="200px" :page-size="5">
        <template slot="columns">
          <el-table-column label="直播时间" prop="live_time" width="120" align="center">
            <template slot-scope="{row}">
              <span>{{ $utils.parseTime(row.live_time || '', '{y}年{m}月{d}日') }}</span>
            </template>
          </el-table-column>
          <el-table-column label="红人" prop="artist_name" width="120" align="center"/>
          <el-table-column label="直播佣金率" prop="live_c_rate" width="120" header-align="center" align="center">
            <template slot-scope="{row}">
              <span class="rate">{{ row.live_c_rate || '' }}</span>
            </template>
          </el-table-column>
          <el-table-column label="直播场次" prop="live_session" width="120" align="center"/>
          <el-table-column label="直播机制" prop="live_sm" width="120" align="center"/>
          <el-table-column label="直播销售数量" prop="live_sales_qty" width="120" header-align="center" align="center"/>
          <el-table-column label="直播GMV" prop="live_gmv" width="120" header-align="center" align="center"/>
          <el-table-column label="主次推情况" prop="live_promotion" width="160" align="center"/>
          <el-table-column label="操作" width="100" align="center">
            <template slot-scope="{row}">
              <el-link v-permission="'order_live_data_record_save'" type="primary" v-if="row.id" @click="editBtn(row)"
                       icon="el-icon-edit"></el-link>
              &nbsp;&nbsp;&nbsp;&nbsp;
              <el-link v-permission="'order_live_data_record_delete'" type="primary" v-if="row.id"
                       @click="deleteBtn(row.id)" icon="el-icon-delete"></el-link>
            </template>
          </el-table-column>
        </template>
      </ml-table>
    </div>

    <!--  直播进度  -->
    <live-data-schedule :key="key" :order-id="orderId" style="margin-top: 20px;"/>

    <!--    弹窗-->
    <el-dialog
        :title='dialogTitle'
        :visible.sync="dialogVisible"
        width="600px"
        center
        custom-class="live-data-dialog"
        :before-close="handleClose">
      <div class="form-card-box">
        <el-form ref="form" :rules="rules" :label-position="'right'" label-width="100px" :model="formData" size="small">
          <el-form-item label="直播时间" :prop="'live_time'" required>
            <el-date-picker
                v-model="formData.live_time"
                type="date"
                value-format="yyyy-MM-dd"
                placeholder="选择直播日期">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="红人昵称" :prop="'artist_id'">
            <PinYinMatchSelect ref="refKolSelect" :data="artistOption" :is-multiple="false"
                               :model-value.sync="formData.artist_id"
                               placeholder="请选择红人" size="small" @focus="getFBoySelectList" @change="handleChange"
                               style="width: calc(100% - 120px)"/>
          </el-form-item>
          <el-form-item label="直播佣金率" :prop="'live_c_rate'">
            <el-input class="el-input-c" oninput="value=value.replace(/[^\d^\.^\-]/g,'')" v-model="formData.live_c_rate"
                      placeholder="请输入直播佣金率(2位小数)" clearable>
              <template slot="append">%</template>
            </el-input>
          </el-form-item>
          <el-form-item label="直播场次" :prop="'live_session'">
            <el-input class="el-input-c" v-model="formData.live_session" placeholder="请输入直播场次"
                      clearable maxlength="50" show-word-limit></el-input>
          </el-form-item>
          <el-form-item label="直播机制" :prop="'live_sm'">
            <el-input class="el-input-c" v-model="formData.live_sm" placeholder="直播机制" clearable maxlength="200"
                      show-word-limit></el-input>
          </el-form-item>
          <el-form-item label="直播销售数量" :prop="'live_sales_qty'">
            <el-input class="el-input-c"
                      oninput="value=value.replace(/[^\d^\.^\-]/g,'')"
                      v-model="formData.live_sales_qty" placeholder="直播销售数量(整数)"
                      clearable>
            </el-input>
          </el-form-item>
          <el-form-item label="直播GMV" :prop="'live_gmv'">
            <el-input class="el-input-c"
                      oninput="value=value.replace(/[^\d^\.^\-]/g,'')"
                      v-model="formData.live_gmv" placeholder="直播GMV（2位小数）"
                      clearable>
              <template slot="append">元（人民币）</template>
            </el-input>
          </el-form-item>
          <el-form-item label="主次推情况" :prop="'live_promotion'">
            <el-select v-model="formData.live_promotion"
                       placeholder="请选择主次推情况"
                       clearable>
              <el-option-group :label="`请选择主次推情况`">
                <el-option v-for="(item, index) in promotionOptions" :key="index" :label="item.label"
                           :value="item.label"/>
              </el-option-group>
            </el-select>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="dialogVisible = false">取 消</el-button>
        <el-button size="small" type="primary" @click="onSubmit">确 定</el-button>
      </div>
    </el-dialog>

  </div>
</template>

<script>
import {deleteOrderLiveData, getOrderLiveDataList, saveOrderLiveData} from "@/api/order";
import {getFBoyOption} from "@/api/fboy";
import LiveDataSchedule from "./LiveDataSchedule.vue";
import MlTable from "../../../../components/MlTable/index.vue";

export default {
  name: "LiveDataTable",
  components: {MlTable, LiveDataSchedule},
  props: {
    orderId: {
      type: [Number, String],
      required: true
    }
  },
  data() {
    return {
      key: new Date().getTime(),
      loading: false,
      dataList: [],
      dialogVisible: false,
      formData: {},
      promotionOptions: [
        {label: '主推', value: '主推'},
        {label: '次推', value: '次推'},
        {label: '挂链', value: '挂链'},
      ],
      rules: {
        live_time: [
          {required: true, message: '请选择直播时间', trigger: 'change'},
        ],
        live_promotion: [{required: true, message: '请选择主次推情况', trigger: ['change', 'blur']},],
        artist_id: [{required: true, message: '请选择红人', trigger: ['change', 'blur']},]
      },
      calcFields: ['live_sales_qty', 'live_gmv'],
      artistOption: []
    }
  },
  computed: {
    dialogTitle() {
      let title = `${this.formData && this.formData.id ? '编辑' : '添加'}直播信息`
      return title
    },
  },
  methods: {
    getOrderLiveDataList,
    getSummaries(param) {
      const {columns, data} = param
      const sums = []
      columns.forEach((column, index) => {
        if (index < 1) {
          return
        }
        if (index === 1) {
          sums[index] = '合计'
          return
        }
        if (this.calcFields.indexOf(column.property) > -1) {
          const values = data.map(item => {
            return Number(item[column.property])
          })
          if (!values.every(value => isNaN(value))) {
            sums[index] = values.reduce((prev, curr) => {
              const value = Number(curr)
              if (!isNaN(value)) {
                return prev + curr
              } else {
                return prev
              }
            }, 0)
            sums[index] += ''
          } else {
            sums[index] = 'N/A'
          }
          // 格式化数据
          // sums[index] = this.moneyFormat(sums[index])
        }
      })

      return sums
    },
    moneyFormat(val) {
      return this.$utils.numberFormat(val, 2, ',')
    },
    async getList() {
      if (this.orderId) {
        this.$refs.MlTable.handleSearch()
      }
    },
    handleAdd() {
      this.formData = {}
      this.dialogVisible = true
    },
    handleClose() {
      this.formData = {}
      this.dialogVisible = false
      this.getList()
    },
    onSubmit() {
      this.$refs['form'].validate(async (valid) => {
        if (valid) {
          this.onSubmitLoading = true
          this.formSubmit()
        } else {
          this.$message.error('数据验证失败，请检查必填项数据！')
        }
      })
    },
    formSubmit() {
      this.formData['order_id'] = this.orderId
      saveOrderLiveData(this.formData).then((res) => {
        if (res.success) {
          this.showToast({
            h: this,
            text: '保存成功'
          });

          this.handleClose()
        }

      })
    },
    editBtn(row) {
      this.formData = row
      this.dialogVisible = true
    },
    //删除记录
    deleteBtn(id) {
      this.$msgbox.confirm('此操作将永久删除该记录, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.deleteRow(id)
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },
    //删除
    async deleteRow(id) {
      await deleteOrderLiveData({id: id}).then(res => {
        return res.model
      })
      this.$nextTick(() => {
        this.getList()
      })
    },
    //红人
    getFBoySelectList() {
      try {
        if (this.artistOption.length === 0) {
          getFBoyOption({}).then((_list) => {
            if (Array.isArray(_list.model) && _list.model.length > 0) {
              this.artistOption = _list.model
            }
          });
        }
        // eslint-disable-next-line
      } catch (error) {
      }
    },
    handleChange(val) {
      // eslint-disable-next-line no-console
      // console.log(val)
      let option = this.$refs['refKolSelect'].getValNode(val)
      // console.log('option', option)
      this.formData.artist_name = option.nickname || ''
    }
  },
  mounted() {
    this.getList()
  }
}
</script>

<style scoped>
::v-deep .el-form-item__content {
  margin-left: 10px !important;
}

.form-card-box {
  border-radius: 6px;
  border: 1px solid rgba(221, 221, 221, 1);
  margin: 0 auto;
  padding: 10px 20px;
}
</style>
<style lang="scss">
.live-data-dialog {
  .el-input, .el-select {
    width: calc(100% - 120px);
  }

  .el-select {
    .el-input {
      width: 100%;
    }
  }
}
</style>
